// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"493":"backoffice","842":"map"}[chunkId] + "-legacy." + {"493":"af048d5f","842":"d20e035b"}[chunkId] + ".js";
};